import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../lib/cn.js';

/**
 * Skeleton — placeholder animado para estados de carga.
 *
 * Uso típico:
 *   <Skeleton className="h-14 w-full" />            (línea)
 *   <Skeleton className="h-32 w-32 rounded-full" /> (avatar)
 *
 * El consumidor define la dimensión; el componente solo aporta el fondo
 * `surface-muted` y la animación pulse. Sigue el patrón de shadcn pero
 * usa nuestros tokens.
 */
export const Skeleton = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={cn('animate-pulse rounded-md bg-surface-muted', className)}
      {...props}
    />
  ),
);
Skeleton.displayName = 'Skeleton';
